import DictionaryService from '@/services/dictionaryService';
import { createI18n } from 'vue-i18n';

// This module initializes the i18n instance.
// It also exports the global i18n instance so it can be used in modules where useI18n can't be used.
// This avoids "SyntaxError: Must be called at the top of a `setup` function".

const i18nInstance = createI18n({
    locale: 'da-DK',
    missing: () => '',
    messages: {},
    legacy: false,
    silentTranslationWarn: true
});

export function setupI18n(lang: string): any {
    i18nInstance.global.locale.value = lang;

    const dictionaryService = new DictionaryService();

    dictionaryService.Get(lang).then((dictionary) => {
        i18nInstance.global.mergeLocaleMessage(lang, dictionary.data);
    });

    return i18nInstance;
}

export const i18n = i18nInstance.global;
